import React from 'react'

import useBreakpoint, { Screen } from 'hooks/useBreakpoint'

interface BreakPointProps {
  hide?: boolean
  show?: boolean
  phone?: boolean
  tablet?: boolean
  desktop?: boolean
  children: React.ReactNode
}

export const Breakpoint: React.FC<BreakPointProps> = (props) => {
  const { phone, tablet, desktop, children, show, hide } = props
  const breakPoint = useBreakpoint()

  if (hide && show) throw Error('select hide or show')

  if (breakPoint === Screen.PHONE) {
    if ((phone && show) || (!phone && hide && (tablet || desktop))) {
      return <>{children}</>
    }
  } else if (breakPoint === Screen.TABLET) {
    if ((tablet && show) || (!tablet && hide && (phone || desktop))) {
      return <>{children}</>
    }
  } else if (breakPoint === Screen.DESKTOP) {
    if ((desktop && show) || (!desktop && hide && (phone || tablet))) {
      return <>{children}</>
    }
  }

  return null
}
